import { useToast } from "@/hooks/use-toast";
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from "@/components/ui/toast";

const ToastProgress = () => {
  return (
    <div className="absolute bottom-0 left-0 right-0 h-1 bg-border/20 overflow-hidden">
      <div className="h-full bg-primary animate-toast-progress" />
    </div>
  );
};

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider duration={5000}>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
            <ToastProgress />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
